import PropTypes from "prop-types";
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React, {
	Component
} from "react";
import validator from "is-my-json-valid";
import memoize from "memoizee";

import Output from "./Output";
import InputContainer from "../Inputs/Layout/InputContainer";
import InputLabel from "../Inputs/Layout/InputLabel";

var makeValidator = memoize(validator);

var VALIDATOR_OPTIONS = {
	verbose: true,
	formats: {
		"email": /^[^ ]+@[^ ]+$/,
	}
};

export default class OutputForm extends Component {
	constructor(props) {
		super(props);
	}

	getChildContext() {
		return {
			externalForms: this.props.externalForms || this.context.externalForms ||  {}
		};
	}

	render(){
		var props = this.props;
		var schema = props.schema || {};
		var subschema = schema.properties || {};
		var data = props.data;
		var dependencies = schema.dependencies || schema.displayDependencies || {};
		var ignoreDependencies = schema.ignoreDependencies;
		var returnValue = Object.keys(subschema)
			.filter(function(propertyName){
				if(ignoreDependencies)
					return true;
				var satisfied = true;
				var dependency = dependencies[propertyName];
				var dependencyType = typeof dependency;

				if (dependencyType === "string") satisfied = data[dependency];
				else if (dependency && dependencyType === "object") {
					if (Array.isArray(dependency)) {
						satisfied = dependency.every(function (subDependency) {
							return data[subDependency];
						});
					} else {
						var validate = makeValidator(dependency, VALIDATOR_OPTIONS);
						validate(data);
						satisfied = !validate.errors;
					}
				}

				return (subschema[propertyName].displayType !== "hidden") && satisfied;

			}).sort(function(a, b) {
				var orderA = subschema[a].order;
				var orderB = subschema[b].order;

				return (orderA - orderB) || 0;
			}).map(function(section, index){
				var dataText = data ? data[section] : null;
				var sectionSchema = subschema[section] || {};
				if (sectionSchema.alwaysDisplay && !dataText) dataText = true;

				return (dataText) ? (
					<Output key={index} schema={subschema[section]} data={dataText} contrast={props.contrast}  noPdfFullScreen={props.noPdfFullScreen} />
				) : null;
			});

		return (
			<InputContainer style={props.style}>
				<InputLabel contrast={props.contrast} schema={schema} />
				{returnValue}
			</InputContainer>
		);
	}
}

OutputForm.propTypes = {
	schema: PropTypes.object
};

OutputForm.contextTypes = {
	localize: PropTypes.func
};

OutputForm.childContextTypes = {
	externalForms: PropTypes.object
};

